<template>
  <nav class="navbar navbar-expand-lg navbar-dark custom-navbar sticky-navbar">
    <div class="container">
      <!-- Brand -->
      <router-link to="/" class="navbar-brand">
        <span class="brand-text">SOLDIERS</span>
        <img src="/images/logo.png" alt="Logo" class="brand-logo" />
        <span class="brand-highlight">Gym</span>
      </router-link>

      <!-- Toggle button for mobile view -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar Items -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <!-- Home -->
          <li class="nav-item" :class="{ active: isActive('/') }">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>
          
          <!-- About Us -->
          <li class="nav-item" :class="{ active: isActive('/aboutus') }">
            <router-link to="/aboutus" class="nav-link">About Us</router-link>
          </li>

          <!-- Gallery -->
          <li class="nav-item" :class="{ active: isActive('/gallery') }">
            <router-link to="/gallery" class="nav-link">Gallery</router-link>
          </li>

          <!-- Services Dropdown -->
          <li class="nav-item dropdown" :class="{ active: isActive('/services') }">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="servicesDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Services
            </a>
            <ul class="dropdown-menu" aria-labelledby="servicesDropdown">
              <li><a class="dropdown-item" href="#">Functional Training</a></li>
              <li><a class="dropdown-item" href="#">Fitness Bootcamp</a></li>
              <li><a class="dropdown-item" href="#">Body Transformation</a></li>
              <li><a class="dropdown-item" href="#">Weight Loss & Weight Gain</a></li>
            </ul>
          </li>

          <!-- Blog -->
          <li class="nav-item" :class="{ active: isActive('/blog') }">
            <router-link to="/blog" class="nav-link">Blog</router-link>
          </li>

          <!-- Contact Us -->
          <li class="nav-item" :class="{ active: isActive('/contact') }">
            <router-link to="/contact" class="nav-link">Contact Us</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  computed: {
    // Computed property for the current route path
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    // Method to check if the route is active
    isActive(route) {
      return this.currentPath === route;
    },
  },
};
</script>

<style scoped>
/* Sticky Navbar */
.sticky-navbar {
  position: sticky;
  top: 0;
  z-index: 1030;
  transition: box-shadow 0.3s ease-in-out;
}

/* Custom Navbar Background */
.custom-navbar {
  background-color: rgba(33, 37, 41, 1) !important; /* #212529 */
}

/* Shadow on scroll */
.sticky-navbar.scrolled {
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.25);
}

/* Brand Styling */
.navbar-brand {
  display: flex;
  align-items: center;
  font-family: "fantasy";
  font-weight: 900;
  font-size: 2.8rem;
  letter-spacing: 2px;
  color: #ffc107;
  text-transform: uppercase;
  transition: transform 0.3s ease, color 0.3s ease;
}

.brand-text,
.brand-highlight {
  font-weight: 900;
  color: #ffc107;
  text-transform: uppercase;
  position: relative;
  display: inline-block;
}

/* Round Logo Styling */
.brand-logo {
  width: 70px;
  height: 65px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 10px;
}

/* Navbar Links */
.navbar-nav .nav-link {
  color: #ffc107 !important;
  font-weight: 700;
  font-size: 1rem; /* Adjusted font size */
  transition: color 0.3s ease, transform 0.3s ease;
}

.navbar-nav .nav-link:hover {
  color: white !important;
  text-decoration: none;
  transform: scale(1.1); /* Add hover scale effect */
}

/* Active Link Styling */
.nav-item.active .nav-link {
  color: #ffc107 !important; /* Highlight active link */
  font-weight: 800;
  text-decoration: underline; /* Optional underline */
  text-decoration-color: #ffc107; /* Make the underline the same color as the text */
  text-decoration-thickness: 3px; /* Make the underline thicker */
  text-decoration-skip-ink: none; /* Ensure the underline doesn't skip any parts of the text */

}

/* Dropdown Menu */
.dropdown-menu {
  background-color: #000;
  border-radius: 8px; /* Softer edges */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  min-width: 200px;
}

.dropdown-item {
  color: #ffc107 !important;
  font-weight: 700;
  padding: 10px 15px;
  transition: all 0.3s ease-in-out;
}

.dropdown-item:hover {
  background-color: #2b2a2a;
  color: white !important;
  text-decoration: none;
}

/* Navbar Toggler */
.navbar-toggler {
  border-color: #ffc107;
}

.navbar-toggler-icon {
  background-color: #ffc107;
}

/* Responsive Adjustments */
@media (max-width: 992px) {
  .navbar-brand {
    font-size: 1.5rem;
  }

  .brand-logo {
    width: 50px;
    height: 50px;
  }
}
</style>
